import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const createTestCompany = payload =>
  api.post(`/platform/testCompany`, payload.data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    params: payload.params,
  })
const createTestCompanyNoneFile = payload =>
  api.post(`/platform/testCompany/none`, payload.data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    params: payload.params,
  })

const deleteTestCompany = payload => api.delete(``, payload)

const modifyTestCompany = payload =>
  api
    .post(``, payload)
    .then(response => response.data)
    .catch(error => {
      throw error
    })

const getTestCompany = payload => api.get(`/platform/company/dns/record`, payload)

const getPreviewLogo = payload => api.get(``, payload)

export default {
  createTestCompany,
  createTestCompanyNoneFile,
  deleteTestCompany,
  modifyTestCompany,
  getTestCompany,
  getPreviewLogo,
}
